import { call } from "redux-saga/effects";

import entity from "core/entity";
import { changePropositionsApi } from "serverApi";

export default (actions, propositionsEntity) =>
    function* (idObject) {
        yield call(entity.load, propositionsEntity, () => changePropositionsApi.getChangePropositions(idObject));
    };
